export interface ModuleDefinition {
  id: string;
  icon: string;
  name: string;
  desc: string;
  required?: boolean;
}

export const MODULE_DEFINITIONS: ModuleDefinition[] = [
  { id: 'properties', icon: '🏢', name: '物件管理', desc: '全プラン必須機能。無効化不可。', required: true },
  { id: 'crm', icon: '👥', name: '顧客 CRM', desc: 'Standard 以上で有効。' },
  { id: 'contracts', icon: '📋', name: '電子契約・書類生成', desc: 'Standard 以上で有効。' },
  { id: 'portals', icon: '📡', name: 'ポータル一括入稿', desc: 'Standard（3媒体）/ Professional 以上（全媒体）。' },
  { id: 'rent_management', icon: '💰', name: '家賃・入金管理', desc: 'Professional 以上 or アドオン契約時。' },
  { id: 'ai_agent', icon: '🤖', name: 'AI エージェント（β）', desc: 'Enterprise or アドオン契約時。' },
];

export const MODULE_IDS = MODULE_DEFINITIONS.map(m => m.id);

export const MODULE_LABELS: Record<string, string> = Object.fromEntries(
  MODULE_DEFINITIONS.map(m => [m.id, m.name])
);
